import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ListItem.scss';

export default class ListItem extends Component {
    static propTypes = {
        item: PropTypes.any.isRequired,
        onGoToItem: PropTypes.func
    };

    static defaultProps = {
        item: {}
    };

    render() {
        const firstMerchantIds = _.join(_.slice(this.props.item.merchantIds, 0, 2), ', ');
        const remainingMerchantCount = _.size(this.props.item.merchantIds) - 2;

        return (<div className="user-with-rules-list-item" onClick={this.props.onGoToItem}>
            <div className="names-and-role">
                <div className="user-info">
                    <div className="user-name">{this.props.item.userName}</div>
                    <div className="merchant-ids">{firstMerchantIds} {remainingMerchantCount > 0 ? `(+${remainingMerchantCount})` : ''}</div>
                </div>
                <div className="role">
                    {_.get(this.props.item, 'rules.length') || 0} Rules
                </div>
            </div>
        </div>);
    }
}
